import { centsToFormattedDollars } from '@fruitful/fruitils';
import {
    type AccountBalancesWidgetProps,
    type AccountBalanceWidgetItem,
} from '@fruitful/types';
import React from 'react';
import { AccountRow, H5Emphasized, RowList, YStack } from 'smoothie';

interface AccountBalancesWidgetComponentProps extends AccountBalancesWidgetProps {
    onPressAccount?: (account: AccountBalanceWidgetItem) => void;
}

export const AccountBalancesWidget = ({
    title,
    accounts,
    onPressAccount,
}: AccountBalancesWidgetComponentProps) => {
    if (accounts.length === 0) return null;

    return (
        <YStack width="100%" gap={12}>
            {title != null && title !== '' && (
                <H5Emphasized color="$black">{title}</H5Emphasized>
            )}
            <RowList paddingVertical={4}>
                {accounts.map((account, index) => (
                    <AccountRow
                        key={`${account.syncteraAccountId}-${index}`}
                        accountName={account.name}
                        accountIcon={account.icon}
                        accountColor={account.color}
                        isJointAccount={false}
                        isJointMembership={false}
                        balance={centsToFormattedDollars(
                            account.availableBalanceCents,
                        )}
                        onPress={
                            onPressAccount != null
                                ? () => {
                                      onPressAccount(account);
                                  }
                                : undefined
                        }
                    />
                ))}
            </RowList>
        </YStack>
    );
};
